/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Distributor,
    DistributorFromJSON,
    DistributorFromJSONTyped,
    DistributorToJSON,
} from './Distributor';

/**
 * GET /distributors
 * @export
 * @interface GetDistributorsSuccessResponse
 */
export interface GetDistributorsSuccessResponse {
    /**
     * 
     * @type {number}
     * @memberof GetDistributorsSuccessResponse
     */
    status: number;
    /**
     * エラーメッセージ。原則英語。
     * @type {string}
     * @memberof GetDistributorsSuccessResponse
     */
    message: string;
    /**
     * 
     * @type {Array<Distributor>}
     * @memberof GetDistributorsSuccessResponse
     */
    data: Array<Distributor>;
}

export function GetDistributorsSuccessResponseFromJSON(json: any): GetDistributorsSuccessResponse {
    return GetDistributorsSuccessResponseFromJSONTyped(json, false);
}

export function GetDistributorsSuccessResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetDistributorsSuccessResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': ((json['data'] as Array<any>).map(DistributorFromJSON)),
    };
}

export function GetDistributorsSuccessResponseToJSON(value?: GetDistributorsSuccessResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': ((value.data as Array<any>).map(DistributorToJSON)),
    };
}

